<template>
  <div class="item" :data-nutrient="item.key">
    <div class="side nut">
      <app-sel
        styling="inline"
        v-if="isSeveralTyped"
        v-model="selected"
        :items="nutrient.types"
        key-name="label"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="nut"
            v-for="nut in items"
          >
            {{ nut.label }}
          </app-sel-opt>
        </template>
      </app-sel>
      <div class="as-default" v-else>
        {{ item.key }}
      </div>
    </div>
    <div class="side nut" v-if="item.units">
      <app-sel
        styling="inline"
        v-model="selectedUnit"
        key-name="label"
        :items="Object.keys(item.units).map(n => { return { label: n } })"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="unit"
            v-for="unit in items"
            v-if="unit.label == 'ppm' || unit.label == 'mmol' || unit.label == 'mg/L' || unit.label == 'meq/L'"
          >
            {{ $ml.get(unit.label) }}
          </app-sel-opt>
        </template>
      </app-sel>
    </div>
    <div class="side value">
      <app-number-input
        v-if="item.key != 'N'"
        class="in-st"
        :placeholder="$ml.get(`Enter value`)"
        :value="convert()"
        @input="onInput"
      />
      <app-number-input
        :readonly="isReadonly"
        v-else
        class="in-st"
        :placeholder="$ml.get(`Enter value`)"
        :value="convert()"
        @input="onInput" 
        :max="getMax()"
      />
      <!-- <app-number-input
        v-else
        class="in-st"
        :placeholder="$ml.get(`Enter value`)"
        v-model="item.value"
      /> -->
    </div>
  </div>
</template>

<script>
import { NutrientConverter } from '@/mixins/nutrient-converter.mixin';
import { UnitConverter } from '@/mixins/unit-converter.mixin';

export default {
  mixins: [ NutrientConverter, UnitConverter ],
  props: {
    item: {

    },
  },
  methods: {
    getMax() {
      return this.$store.state.tests.water.maxNCount;
    },
    onInput(value) {

      // unconverting view
      if (this.isSeveralTyped) {
        value = this.unconvertNutrientType(this.item.key, this.selected, value);
      }
      this.item.value = this.toPpm(this.item.key, this.selectedUnit, value);

      const n_1 = this.$store.state.tests.water.form.data.find(n => n.key === 'NNO3').value
      const n_2 = this.$store.state.tests.water.form.data.find(n => n.key === 'NNH4').value
      const n_3 = this.$store.state.tests.water.form.data.find(n => n.key === 'NNH2').value

      if(this.item.n_form ) {
        if(n_1 > 0 || n_2 > 0 || n_3 > 0) {
          this.$store.commit('tests/water/computeN', {use_n_form: true});
        } else {
          if(this.item.value == null) {
              this.$store.commit('tests/water/setMax', {value: 9999999});
              return false
          } else this.$store.commit('tests/water/computeN', {use_n_form: false});
        }
      }
    },

    // converting view
    convert() {
      let val = this.item.value;
      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.item.key, this.selected, this.item.value);
      }
      val = this.toUnit(this.item.key, this.selectedUnit, val);
      return val ? val.toFixedGentle(2) : null;
    },
  },
  data() {
    return {
      selected: null,
      selectedUnit: 'ppm'
    }
  },
  created() {
    if(this.isSeveralTyped) {
      this.selected = this.nutrient.types[0].label;
    }
  },
  computed: {

    isReadonly () {
      const n_1 = this.$store.state.tests.water.form.data.find(n => n.key === 'NNO3').value
      const n_2 = this.$store.state.tests.water.form.data.find(n => n.key === 'NNH4').value
      const n_3 = this.$store.state.tests.water.form.data.find(n => n.key === 'NNH2').value

      return (n_1 > 0 || n_2 > 0 || n_3 > 0) ? true : false
    },

    nutrient() {
      return this.$store.getters['nutrients/getNutrientByKey'](this.item.key);
    },

    isSeveralTyped() {
      return this.nutrient.types ? true : false;
    },

    // precessedTypes() {
    //   if(this.isSeveralTyped) {
    //     return this.item.types.map(n => {
    //       n.key = n.label;
    //       return n;
    //     });
    //   }
    // }
  },
  watch: {
    'item.value': function (val) {
      this.$store.dispatch('tests/water/computeEC');
    }
  }
}
</script>

<style lang="scss" scoped>

.item {
  border-bottom: 1px solid #E4E5E6;
  height: 60px;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .side {

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    width: 50%;

    &.nut {
      .as-default {
        padding: 8px 12px;
      }
      .app-sel {
        min-width: 120px;
      }
    }
    &.value {
      color: $mainGreen;
      font-size: 16px;

      input {
        color: $mainGreen;
        font-size: 16px;
      }
      .text-input {
        min-width: 120px;
      }
    }


  }
}

</style>
